import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { FONT, WEIGHT, INK } from "../../../theme/tokens";

// Static label rendered above a form control — the app's standard field-label
// style (matches SubHeader and the InputWithSlider label). Pairs with a
// placeholder-bearing, label-less control so every field reads the same way,
// replacing MUI's floating labels.
export default function FieldLabel({ htmlFor, children, sx }) {
  return (
    <Typography
      component="label"
      htmlFor={htmlFor}
      sx={{
        display: "block",
        mb: 1,
        fontSize: FONT.md,
        fontWeight: WEIGHT.semibold,
        color: INK,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

FieldLabel.propTypes = {
  htmlFor: PropTypes.string,
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};
